module.exports = __webpack_public_path__ + "static/media/acto_de_grado_4.58fa917f.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/carousel/acto_de_grado_4.jpg
// module id = 911
// module chunks = 0